import { ApiError, login } from '../auth/api.js';
import { auth } from '../auth/state.js';
import type { Router } from '../router.js';
import { hasEmoji, renderTextWithIcons } from './inline_icons.js';

export function renderLogin(container: HTMLElement, router: Router): void {
  container.innerHTML = '';
  container.classList.add('overlay-screen');

  const card = el('div', 'auth-card');
  // Title with a friendly cat sprite next to it for the "cute kingdom" vibe.
  const title = el('h1', 'auth-title');
  const titleIcon = document.createElement('img');
  titleIcon.src = '/sprites/iconchat_valide.png';
  titleIcon.className = 'auth-title-icon';
  titleIcon.alt = '';
  title.appendChild(titleIcon);
  title.appendChild(document.createTextNode('Rentrer au panier'));
  card.appendChild(title);
  card.appendChild(el('p', 'auth-sub', '🐾 Le coussin est encore chaud, viens te poser'));

  const form = document.createElement('form');
  form.className = 'auth-form';
  form.noValidate = true;

  const idInput = inputField('Pseudo ou email', 'identifier', 'text', 'username');
  const pwInput = inputField('Mot de passe', 'password', 'password', 'current-password');
  const errBox = el('div', 'auth-error');

  const submit = document.createElement('button');
  submit.type = 'submit';
  submit.className = 'auth-submit';
  submit.textContent = '🐾 Se connecter';

  form.append(idInput.wrap, pwInput.wrap, errBox, submit);

  const switchLine = el('p', 'auth-switch');
  switchLine.innerHTML =
    'Pas encore de compte ? <a href="/signup">Crée-en un</a>';

  card.append(form, switchLine);
  container.appendChild(card);

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    errBox.textContent = '';
    submit.disabled = true;
    submit.textContent = 'Connexion…';
    try {
      const user = await login(idInput.input.value.trim(), pwInput.input.value);
      auth.user = user;
      router.navigate('/');
    } catch (err) {
      errBox.textContent =
        err instanceof ApiError ? err.message : 'Erreur réseau, réessaie.';
    } finally {
      submit.disabled = false;
      submit.textContent = 'Se connecter';
    }
  });

  // Autofocus first field
  setTimeout(() => idInput.input.focus(), 0);
}

// ----------------------------------------------------------------------------
// Tiny DOM helpers (also used by signup)

export function el(
  tag: keyof HTMLElementTagNameMap,
  className?: string,
  text?: string,
): HTMLElement {
  const e = document.createElement(tag);
  if (className) e.className = className;
  if (text) {
    // If the text carries any emoji we know about, route it through the
    // pixel-icon renderer so the system emoji glyph is replaced by a
    // matching sprite. Plain (non-emoji) text falls back to a cheap
    // textContent assignment — no DOM nodes wasted.
    if (hasEmoji(text)) {
      e.appendChild(renderTextWithIcons(text));
    } else {
      e.textContent = text;
    }
  }
  return e;
}

export function inputField(
  label: string,
  name: string,
  type: 'text' | 'email' | 'password',
  autocomplete: string,
): { wrap: HTMLElement; input: HTMLInputElement } {
  const wrap = el('label', 'auth-field');
  wrap.appendChild(el('span', 'auth-field-label', label));
  const input = document.createElement('input');
  input.type = type;
  input.name = name;
  input.autocomplete = autocomplete as AutoFill;
  input.required = true;
  input.className = 'auth-input';
  wrap.appendChild(input);
  return { wrap, input };
}
